//@flow
import React from 'react';
import { Link } from 'react-router';

import type CategoryModel from '../../Stores/MemberCategories/categoryModel';

type Props = {
  category:CategoryModel,
  isOffice?:boolean,
};

export default function CategoryCard(props:Props) {
  const url = props.isOffice
    ? props.category.getOfficeUrl()
    : props.category.getUrl();
  return (
    <li className="grid-item category-card">
      <Link to={url}>
        <div className="category-card-image-container">
          <img src={props.category.getThumbnailImageUrl()} alt=""/>
        </div>
        <div className="category-card-name">{props.category.getName()}</div>
      </Link>
    </li>
  );
}
